// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ue56","newExpiryDate":"styles_newExpiryDate__2Zni1","footer":"styles_footer__3n4cA"};